/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAddressBrandAuthSrcTypeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // Listeleme → getlist
        getAllDealerAddressBrandAuthSrcType: builder.query({
            query: ({ addressBrandId, pageNumber = 1, pageSize = 10 }) => ({
                url: 'v1/dealeraddressbrandauthsrctype/getlist',
                method: 'POST',
                body: {
                    addressBrandId,
                    pageNumber,
                    pageSize
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return { items: [], count: 0 };
            },
            providesTags: ['DealerAddressBrandAuthSrcType']
        }),

        // ID ile getbyid
        getByIdDealerAddressBrandAuthSrcType: builder.query({
            query: (id) => ({
                url: 'v1/dealeraddressbrandauthsrctype/getbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrandAuthSrcType', id }]
        }),

        // Ekleme → add
        createDealerAddressBrandAuthSrcType: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandauthsrctype/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAuthSrcType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        // Güncelleme → update
        updateDealerAddressBrandAuthSrcType: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandauthsrctype/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAuthSrcType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        // Silme → delete
        deleteDealerAddressBrandAuthSrcType: builder.mutation({
            // Hem sayısal id hem { id, dealerAddressBrandId } kabul edilir (id request'e gider,
            // dealerAddressBrandId yalnızca hedefli cache invalidation için kullanılır).
            query: (arg) => {
                const id = arg && typeof arg === 'object' ? arg.id : arg;
                return {
                    url: 'v1/dealeraddressbrandauthsrctype/delete',
                    method: 'DELETE',
                    params: { id }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAuthSrcType', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        })
    })
});

export const {
    useGetAllDealerAddressBrandAuthSrcTypeQuery,
    useGetByIdDealerAddressBrandAuthSrcTypeQuery,
    useCreateDealerAddressBrandAuthSrcTypeMutation,
    useUpdateDealerAddressBrandAuthSrcTypeMutation,
    useDeleteDealerAddressBrandAuthSrcTypeMutation
} = dealerAddressBrandAuthSrcTypeApi;
